import { render, staticRenderFns } from "./ViewerContainer.vue?vue&type=template&id=6be07cad&scoped=true"
import script from "./ViewerContainer.vue?vue&type=script&lang=js"
export * from "./ViewerContainer.vue?vue&type=script&lang=js"
import style0 from "./ViewerContainer.vue?vue&type=style&index=0&id=6be07cad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be07cad",
  null
  
)

export default component.exports